module.exports = __webpack_public_path__ + "img/house-signal.00b6cea.svg";